import { AxiosResponse } from "axios";

import {
  ISurveySyncComparison,
  ISurveySyncResult,
} from "../../@types/admin/AdminSurveySync";
import { api } from "../api";

/**
 * Survey sync (EN-5261): copies THIS region's survey definitions into the
 * Global DB. Insert-only — surveys already in Global are never overwritten.
 */
export const surveysSyncService = {
  /** This region's surveys against Global, sorted by status then name. */
  async getComparison(): Promise<AxiosResponse<ISurveySyncComparison[]>> {
    return api.get<ISurveySyncComparison[]>("/Retool/Surveys/Sync/Comparison");
  },

  /** Insert the surveys missing from Global. Safe to re-run. */
  async sync(): Promise<AxiosResponse<ISurveySyncResult>> {
    return api.post<ISurveySyncResult>("/Retool/Surveys/Sync");
  },
};
